// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___rvOIh","toast":"styles__toast___Rwkdn","close":"styles__close___xjtB8","in-right":"styles__in-right___ce5pV"};